<template>
  <MLayoutHeader
    class="header mainAppHeader absolute w-full headerCustom items-center flex-1"
  >
    <MRow :gutter="0" class="flex-1 items-center">
      <MCol :size="6" class="flex items-center ant-col-sm-4 ant-col-md-6">
        <MTooltip v-if="loggedIn" placement="left">
          <template v-slot:trigger>
            <a
              hrem="javascript:;"
              class="px-2"
              @click="$emit('change', !pinned)"
            >
              <MIcon
                name="bars"
                type="fas"
                size="lg"
                :class="{
                  'text-neutral-dark': theme !== 'dark_theme',
                  'text-white': theme === 'dark_theme',
                }"
              />
            </a>
          </template>
          <span>{{ $t(pinned ? 'collapse' : 'expand') }}</span>
        </MTooltip>
        <component
          :is="linkbackRoute ? 'a' : 'FlotoLink'"
          v-bind="{
            ...(linkbackRoute
              ? {
                  href: linkbackRoute,
                  target: '_blank',
                }
              : {
                  to: homeRoute,
                }),
          }"
          class="m-hide"
          :aria-label="$tc('logo')"
        >
          <img :alt="$tc('logo')" :src="companyLogo" height="50" class="mx-6" />
        </component>
        <!-- <h2
          v-if="portalMode"
          style="font-size: 1.4rem"
          class="ml-4 inline-block text-primary mb-0 title-header"
        >
          {{ branding.customerPortalTitle }}
        </h2> -->
      </MCol>
      <MCol :size="6" class="text-right ant-col-sm-8 ant-col-md-6">
        <MRow :gutter="0" class="justify-end rightContainer items-center h-100">
          <CreateDropdown v-if="loggedIn" :portal-mode="portalMode" />
          <FontSizeHandler
            v-if="getSingleTenantPrefrence('enableApplicatonAccessibility')"
          />
          <div v-if="hasCalendarAccess" id="calendar" class="box">
            <FlotoLink
              id="calendar-view-btn"
              class="text-neutral admin-page-link"
              :aria-label="$tc('calendar')"
              :to="$modules.getModuleRoute('calendar')"
            >
              <MTooltip placement="top">
                <template v-slot:trigger>
                  <MIcon name="calendar" size="lg" />
                </template>
                {{ $tc('calendar') }}
              </MTooltip>
            </FlotoLink>
          </div>
          <div v-if="canAccessChat" id="chat" class="box">
            <MBadge :count="pendingCount">
              <FlotoLink
                id="calendar-view-btn"
                class="text-neutral admin-page-link"
                :aria-label="$tc('chat')"
                :to="$modules.getModuleRoute('chat-manager')"
              >
                <MTooltip placement="top">
                  <template v-slot:trigger>
                    <MIcon name="comments-alt" size="lg" />
                  </template>
                  {{ $tc('chat') }}
                </MTooltip>
              </FlotoLink>
            </MBadge>
          </div>
          <div v-if="canAccessMyChats" id="chat" class="box">
            <FlotoLink
              id="calendar-view-btn"
              class="text-neutral admin-page-link"
              :aria-label="$tc('my_chat_history')"
              :to="$modules.getModuleRoute('support-portal', 'chat-history')"
            >
              <MTooltip placement="top">
                <template v-slot:trigger>
                  <MIcon name="comments-alt" size="lg" />
                </template>
                {{ $tc('my_chat_history') }}
              </MTooltip>
            </FlotoLink>
          </div>
          <div
            v-if="hasNotificationAccess"
            id="notification-support"
            class="box notification-support"
          >
            <MTooltip placement="top">
              <template v-slot:trigger>
                <NotificationSupport
                  :count="notificationCount"
                  @onUpdateCount="notificationCount = 0"
                />
              </template>
              {{ $tc('notification') }}
            </MTooltip>
          </div>
          <div
            v-if="!isPortalLogin"
            id="downloads-support"
            class="box notification-support"
          >
            <MTooltip placement="top">
              <template v-slot:trigger>
                <DownloadsDrawer />
              </template>
              {{ $tc('downloads') }}
            </MTooltip>
          </div>
          <div v-if="hasAdminAccess" id="admin" class="box">
            <FlotoLink
              id="calendar-view-btn"
              class="text-neutral admin-page-link"
              :aria-label="$tc('admin')"
              :to="$modules.getModuleRoute('admin')"
            >
              <MTooltip placement="top">
                <template v-slot:trigger>
                  <MIcon name="cog" size="lg" />
                </template>
                {{ $tc('admin') }}
              </MTooltip>
            </FlotoLink>
            <!-- <a href="javascript:;" class="text-neutral">
              <MIcon name="info-circle" size="lg" />
            </a>
            <MBadge :count="2">
              <a href="javascript:;" class="text-neutral">
                <MIcon name="bell" size="lg" />
              </a>
            </MBadge> -->
          </div>
          <div
            v-if="loggedIn && !isCxoTechnician()"
            id="shortcut-helper"
            class="box m-hide"
          >
            <KeyboardShortcutHelper />
          </div>
          <div v-if="isPortalLogin" id="home" class="box">
            <FlotoLink
              id="calendar-view-btn"
              class="text-neutral admin-page-link"
              :aria-label="$t('go_to_home')"
              :to="homeRoute"
            >
              <MTooltip placement="top">
                <template v-slot:trigger>
                  <MIcon name="house" size="lg" />
                </template>
                {{ $t('home') }}
              </MTooltip>
            </FlotoLink>
          </div>
          <div
            v-if="isPortalLogin && branding.helpViewEnable"
            id="help-view"
            class="box"
          >
            <MTooltip>
              <template v-slot:trigger>
                <MButton
                  id="help-view-btn"
                  class="text-neutral admin-page-link"
                  :aria-label="$tc('info')"
                >
                  <a
                    v-if="branding.helpViewType === 'url'"
                    :href="branding.helpViewUrlLink"
                    target="_blank"
                  >
                    <img
                      v-if="branding.helpViewIconForRequesterSrc"
                      :src="branding.helpViewIconForRequesterSrc"
                      style="max-height: 60px"
                    />
                    <MIcon v-else name="info-circle" size="lg" />
                  </a>
                  <FlotoDownloadLink
                    v-else
                    :file-name="branding.helpViewAttachment[0].realName"
                    :url="`/public/download/file/${branding.helpViewAttachment[0].refFileName}`"
                  >
                    <template v-slot="{ downloading }">
                      <img
                        v-if="branding.helpViewIconForRequesterSrc"
                        :src="branding.helpViewIconForRequesterSrc"
                        style="max-height: 60px"
                      />
                      <div v-else>
                        <MIcon
                          v-if="!downloading"
                          name="info-circle"
                          size="lg"
                        />
                      </div>
                    </template>
                  </FlotoDownloadLink>
                </MButton>
              </template>
              {{ $tc('help') }}
            </MTooltip>
          </div>
          <div
            v-if="!isPortalLogin && branding.helpViewEnableForTechnician"
            id="help-view"
            class="box"
          >
            <MTooltip>
              <template v-slot:trigger>
                <MButton
                  id="help-view-btn"
                  class="text-neutral admin-page-link"
                >
                  <a
                    v-if="branding.helpViewTypeForTechnician === 'url'"
                    :href="branding.helpViewUrlLinkForTechnician"
                    target="_blank"
                  >
                    <img
                      v-if="branding.helpViewIconForTechnicianSrc"
                      :src="branding.helpViewIconForTechnicianSrc"
                      style="max-height: 60px"
                    />
                    <MIcon v-else name="info-circle" size="lg" />
                  </a>
                  <FlotoDownloadLink
                    v-else
                    :file-name="
                      branding.helpViewAttachmentForTechnician[0].realName
                    "
                    :url="`public/download/file/${branding.helpViewAttachmentForTechnician[0].refFileName}`"
                  >
                    <template v-slot="{ downloading }">
                      <img
                        v-if="branding.helpViewIconForTechnicianSrc"
                        :src="branding.helpViewIconForTechnicianSrc"
                        style="max-height: 60px"
                      />
                      <div v-else>
                        <MIcon
                          v-if="!downloading"
                          name="info-circle"
                          size="lg"
                        />
                      </div>
                    </template>
                  </FlotoDownloadLink>
                </MButton>
              </template>
              {{ $tc('help') }}
            </MTooltip>
          </div>
          <div v-if="loggedIn" id="user-dropdown" class="box">
            <UserDropdown
              :portal-mode="portalMode"
              :customer-portal-title="branding.customerPortalTitle"
              :technician-portal-title="branding.technicianPortalTitle"
            />
          </div>
          <div v-if="portalMode && !loggedIn" class="box flex">
            <FlotoLink
              as-button
              :to="
                $modules.getModuleRoute('auth', 'login', {
                  params: { portalLogin: true },
                })
              "
              :aria-label="$t('login')"
            >
              {{ $t('login') }}
            </FlotoLink>
            <FlotoLink
              v-if="allowRegistration"
              :to="$modules.getModuleRoute('auth', 'signup')"
              class="ml-2"
              block
              as-button
              variant="primary"
              :aria-label="$t('signup')"
            >
              {{ $t('signup') }}
            </FlotoLink>
          </div>
        </MRow>
      </MCol>
    </MRow>
  </MLayoutHeader>
</template>

<script>
import BrandingMixin from '@src/mixins/branding'
import { isCxoTechnician } from '@utils/auth'
import { PreferenceComputed } from '@state/modules/preference'
import { SupportPortalConfigComputed } from '@state/modules/support-portal-config'
import { authComputed, authMethods } from '@state/modules/auth'
import { LicenseComputed } from '@state/modules/license'
import Bus from '@utils/emitter'
import { transformNotification } from '@data/notification'
import { getDetailLinkForModule } from '@utils/get-module-detail-link'
import { getPendingCountApi } from '@components/chat/chat-api'
import { getNotificationCountApi } from '@components/notification-container/notification-support-api'
import { SsoConfigComputed } from '@state/modules/sso-config'
import {
  UserSecurityConfigMethods,
  UserSecurityConfigComputed,
} from '@state/modules/user-security-config'
import UserDropdown from './user-dropdown'
import CreateDropdown from './create-dropdown'
import KeyboardShortcutHelper from './keyboard-shortcut-helper'
import NotificationSupport from '../notification-container/notification-support'
import { getDelegateApprovalApi } from '@components/layout/profile/api'
import Moment from 'moment'
import { TechnicianComputed } from '@state/modules/technician'
import { getGlobalUserApi } from '@/src/modules/users/users-api'
import FontSizeHandler from './font-size-handler.vue'
import DownloadsDrawer from '@components/downloads/downloads-drawer.vue'
import { reDownloadApi } from '@modules/downloads/downloads-api'
import DownloadFailedNotification from '@components/downloads/download-failed-notification.vue'

export default {
  name: 'Header',
  components: {
    UserDropdown,
    CreateDropdown,
    KeyboardShortcutHelper,
    NotificationSupport,
    FontSizeHandler,
    DownloadsDrawer,
  },
  mixins: [BrandingMixin],
  inject: {
    chatConfigContext: { config: {} },
  },
  props: {
    portalMode: { type: Boolean, default: false },
    pinned: { type: Boolean, default: false },
  },
  data() {
    this.Moment = Moment
    this.isCxoTechnician = isCxoTechnician
    return {
      pendingCount: 0,
      notificationCount: 0,
      notification: {},
      fullUser: {},
      pendingNotifications: {},
    }
  },
  computed: {
    ...SsoConfigComputed,
    ...UserSecurityConfigComputed,
    ...SupportPortalConfigComputed,
    ...PreferenceComputed,
    ...authComputed,
    ...LicenseComputed,
    ...TechnicianComputed,
    canAccessChat() {
      if (this.isPortalLogin) {
        return false
      }
      if (!this.loggedIn) {
        return false
      }
      if (
        this.availableModulesInLicense.indexOf(this.$constants.REQUEST) === -1
      ) {
        return false
      }
      if (isCxoTechnician()) {
        return false
      }
      const isChatEnabled = this.chatConfigContext.config.enabled
      const supportChat = this.chatEnabled
      return isChatEnabled && supportChat
    },
    canAccessMyChats() {
      if (!this.isPortalLogin) {
        return false
      }
      if (!this.loggedIn) {
        return false
      }
      if (
        this.availableModulesInLicense.indexOf(this.$constants.REQUEST) === -1
      ) {
        return false
      }
      if (isCxoTechnician()) {
        return false
      }
      const isChatEnabled = this.chatConfigContext.config.enabled
      return isChatEnabled && this.chatConfigContext.config.viewUserChatHistory
    },
    hasAdminAccess() {
      if (this.portalMode) {
        return false
      }
      if (this.loggedIn && this.myAllowedModules.indexOf('admin') >= 0) {
        return true
      }
      return false
    },
    hasNotificationAccess() {
      if (
        this.loggedIn &&
        !isCxoTechnician() &&
        (this.myAllowedModules.indexOf('request') >= 0 ||
          this.myAllowedModules.indexOf('change') >= 0 ||
          this.myAllowedModules.indexOf('problem') >= 0 ||
          this.myAllowedModules.indexOf('release') >= 0 ||
          this.myAllowedModules.indexOf('asset') >= 0 ||
          this.myAllowedModules.indexOf('project') >= 0 ||
          this.myAllowedModules.indexOf('cmdb') >= 0)
      ) {
        return true
      }
      return false
    },
    hasCalendarAccess() {
      if (this.loggedIn && !this.isPortalLogin && !isCxoTechnician()) {
        return true
      }
      return false
    },
  },
  watch: {
    isPortalLogin: {
      immediate: true,
      handler: 'updateLoginDataBasedOnType',
    },
  },
  created() {
    if (!this.isPortalLogin) {
      const globallyLocaleLoadedHandler = () => {
        this.getDelegateApprovals()
      }
      Bus.$once('app:globallyLocaleLoaded', globallyLocaleLoadedHandler)
      this.$once('hook:beforeDestroy', () => {
        Bus.$off('app:globallyLocaleLoaded', globallyLocaleLoadedHandler)
      })
    }
    const handleChatCountUpdated = (payload) => {
      this.pendingCount = payload
    }
    const handleUiNotificationUpdated = (payload) => {
      if (payload.userId === this.user.id) {
        if (this.isPortalLogin && !payload.cPortalSupportedNotification) {
          return undefined
        }
        const message = (payload.title || '').split(' ').join('')
        if (
          Object.keys(this.pendingNotifications || {}).indexOf(message) >= 0
        ) {
          return undefined
        }
        this.pendingNotifications[message] = setTimeout(() => {
          delete this.pendingNotifications[message]
        }, 5000)
        this.$successNotification({
          message: this.$t(payload.title),
          // description: this.$t(payload.title),
          onClick: () => this.handleNotificationClick(payload),
        })
        return (this.notification = payload)
      }
    }
    const handleUiNotificationCountUpdated = (payload) => {
      if (payload.userId === this.user.id) {
        // this.$successNotification({
        //   message: this.$t('success'),
        //   description: this.$t('notification_sent_success'),
        // })
        // return (this.notificationCount = payload.count)
        this.notificationCount = payload.count
      }
    }

    const handleConcurrentUserLogin = (user) => {
      this.$errorNotification({
        message: this.$t('error'),
        description: this.$t('concurrent_logout'),
      })
      Bus.$emit('auth:logout', user)
    }

    const handleDownloadStatusUpdated = (payload) => {
      const { downloadState = '', id = 0, trackingId = 0 } = payload
      if (downloadState === 'failed') {
        this.$errorNotification({
          message: `${this.$t('download_failed')}`,
          key: `${id}-${trackingId}`,
          onClose: () => {},
          duration: 5,
          description: (h) =>
            h(DownloadFailedNotification, {
              props: {
                copyText: this.$t('click_to_copy'),
                copiedText: this.$t('copied'),
                title: this.$t('reference_id'),
                copy: this.$t('copy'),
                trackingId,
              },
            }),
        })
      } else if (downloadState === 'completed') {
        reDownloadApi(id)
      }
    }

    Bus.$on('pending_chat_count_updated', handleChatCountUpdated)
    this.$once('hook:beforeDestroy', () => {
      Bus.$off('pending_chat_count_updated', handleChatCountUpdated)
    })
    Bus.$on('ui_notification_updated', handleUiNotificationUpdated)
    this.$once('hook:beforeDestroy', () => {
      Bus.$off('ui_notification_updated', handleUiNotificationUpdated)
    })
    Bus.$on('download_status_updated', handleDownloadStatusUpdated)
    this.$once('hook:beforeDestroy', () => {
      Bus.$off('download_status_updated', handleDownloadStatusUpdated)
    })
    Bus.$on('logout_concurrent', handleConcurrentUserLogin)
    this.$once('hook:beforeDestroy', () => {
      Bus.$off('logout_concurrent', handleConcurrentUserLogin)
    })
    Bus.$on('ui_notification_count_updated', handleUiNotificationCountUpdated)
    this.$once('hook:beforeDestroy', () => {
      Bus.$off(
        'ui_notification_count_updated',
        handleUiNotificationCountUpdated
      )
    })
  },
  methods: {
    ...authMethods,
    ...UserSecurityConfigMethods,
    handleNavigation(route1, route2 = undefined) {
      this.$router.push(this.$modules.getModuleRoute(route1, route2))
    },
    getDelegateApprovals() {
      getDelegateApprovalApi(this.user.id).then((data) => {
        this.getUserName(data.userId).then((userName) => {
          let message = ''
          if (
            data.enabled &&
            data.createdBy === this.user.id &&
            Moment().valueOf() > data.startTime
          ) {
            if (
              Moment().valueOf() > data.startTime &&
              Moment().valueOf() < data.endTime
            ) {
              message = `${this.$t('delegate_start_message', {
                user: userName,
                start_date: this.$options.filters.datetime(
                  data.startTime,
                  undefined,
                  false
                ),
              })} ${this.$t('delegate_end_message', {
                end_date: this.$options.filters.datetime(
                  data.endTime,
                  undefined,
                  false
                ),
              })}`
            }
            if (!data.endTime && Moment().valueOf() > data.startTime) {
              message = this.$t('delegate_start_message', {
                user: userName,
                start_date: this.$options.filters.datetime(
                  data.startTime,
                  undefined,
                  false
                ),
              })
            }
            this.$successNotification({
              message: `${this.$tc('delegated')} ${this.$tc('approval')}`,
              description: message,
            })
          }
        })
      })
    },
    getUserName(userId) {
      const promiseList = []
      if (userId) {
        const user = this.technician(userId)
        if (user && user.id) {
          promiseList.push(Promise.resolve(user.name))
        } else {
          promiseList.push(
            getGlobalUserApi(userId, { archived: true }).then((data) => {
              return data.name
            })
          )
        }
      }
      return Promise.all(promiseList)
    },
    handleNotificationClick(payload) {
      const notification = transformNotification(payload)
      if (notification.linkId) {
        const link = getDetailLinkForModule(
          notification.refModel,
          notification.linkId,
          this.$modules,
          notification.type
        )
        if (link.link) {
          return this.$router.push(link.link)
        }
      }
    },
    updateLoginDataBasedOnType() {
      if (this.loggedIn) {
        this.refreshUser()
        getPendingCountApi().then((data) => {
          this.pendingCount = data
        })
        getNotificationCountApi().then((data) => {
          this.notificationCount = data
        })
      }
    },
    onMenuPinnedChange() {
      this.$emit('menu-pin-change')
    },
  },
}
</script>

<style lang="less">
.notification-support {
  .@{ant-prefix}-scroll-number {
    top: 2px;
    right: 2px;
    scale: 0.8;
  }
}
// .mainNavbar {
//   .@{ant-prefix}-layout-sider-children {
//     @apply flex-col flex;
//   }
//   .@{ant-prefix}-menu-item,
//   .@{ant-prefix}-menu-item * {
//     transition: none !important;
//   }
//   .@{ant-prefix}-layout-sider-trigger {
//     display: none;
//   }
//   &.@{ant-prefix}-layout-sider-has-trigger {
//     padding-bottom: 0;
//   }
// }
// .mainMenu {
//   flex: 1;
//   background: none;
//   border-right-width: 0;
//   .exclude-hover {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     span {
//       display: none;
//     }
//   }
//   .@{ant-prefix}-menu-item:not(.exclude-hover):hover,
//   .@{ant-prefix}-menu-item-selected {
//     // color: @primary;
//     background-color: fade(@white, 100%);
//     // stylelint-disable-next-line
//     &::after {
//       right: -5px;
//       width: 10px;
//       background-color: @secondary-yellow;
//       border-radius: 4px;
//       opacity: 1;
//       transform: none !important;
//     }
//   }
// }
// .mainAppHeader {
//   z-index: 10;
//   background: @white;
//   box-shadow: 10px 0 10px 0 rgba(0, 0, 0, 0.3);
//   .rightContainer {
//     line-height: 0;
//   }
//   .box {
//     @apply px-6 border-r-2 border-l-0 border-t-0 border-b-0 border-neutral-lighter border-solid flex items-center justify-center;

//     height: calc(100% - 1rem);
//     &:last-child {
//       @apply border-r-0;
//     }
//     .@{ant-prefix}-badge {
//       @apply mr-2;
//       a {
//         @apply mr-0;
//       }
//     }
//   }
//   .admin-page-link {
//     &.router-link-active {
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       padding: 0.5rem;
//       color: @white;
//       background-color: @primary-color;
//       border-radius: 50%;
//     }
//   }
//   .email-contact {
//     @apply flex flex-col justify-center;
//     & div:nth-child(1) {
//       @apply text-base mb-1;
//     }
//     & div:nth-child(2) {
//       @apply text-xs;
//     }
//   }
// }
</style>
